import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export function BookCard({ book }) {
  return (
    <Link to={`/kitap/${book.id}`} data-testid={`book-card-${book.id}`} className="group block fade-up">
      <div className="aspect-[3/4] rounded-md bg-ink border border-line relative flex items-center justify-center p-3 overflow-hidden">
        <span className="font-serif text-page text-center uppercase tracking-wide leading-tight text-sm line-clamp-5">{book.baslik}</span>
      </div>
      <h3 className="font-serif text-base text-ink mt-2 leading-tight group-hover:text-terra transition-colors line-clamp-2">{book.baslik}</h3>
      <p className="text-xs text-muted-foreground">{book.yazar}</p>
      {book.topluluk_puani > 0 && (
        <div className="flex items-center gap-1 mt-0.5">
          <Star size={12} className="fill-gold text-gold" />
          <span className="text-xs text-ink-2">{book.topluluk_puani}</span>
        </div>
      )}
    </Link>
  );
}
